<template>
    <answers ref="answers"
             code_question_group="GQ28"
             danger_code="MCAL09"
             :unique_category="true"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
